export enum RR_MODAL_CONTENT_TYPE {
  HTML,
  STRING,
}
